/**
 * useDisplayZone — the one place a component asks "which zone do I render in?"
 *
 * Epic #532 display rule: times render in ONE stated zone — the viewer's
 * profile timezone — never whichever machine happens to be rendering. The
 * chain is `contact.timezone → user.timezone (via DisplayZoneContext, fed by
 * AuthProvider) → browser zone`.
 *
 * Reads context/DisplayZoneContext.js rather than useAuth() so timestamp
 * leaves (DataTable cells, inbox rows, workflow log viewers) do not inherit
 * AuthContext's axios/session-dialog dependency tree, and so a tree mounted
 * without an AuthProvider (tests, embeds) resolves cleanly to the browser
 * zone instead of throwing.
 */
import { useContext } from 'react';
import DisplayZoneContext from '../context/DisplayZoneContext';
import { browserTimeZone, isValidTimeZone } from '../lib/timezone';

export default function useDisplayZone({ contact } = {}) {
    const viewerZone = useContext(DisplayZoneContext);
    const contactZone = typeof contact?.timezone === 'string' ? contact.timezone.trim() : '';
    if (contactZone && isValidTimeZone(contactZone)) return contactZone;
    const trimmed = typeof viewerZone === 'string' ? viewerZone.trim() : '';
    return trimmed && isValidTimeZone(trimmed) ? trimmed : browserTimeZone();
}
